import { createContext, useContext, useState, useCallback } from 'react';
import { FiCheck, FiAlertCircle, FiInfo, FiX } from 'react-icons/fi';

const ToastContext = createContext();

export const ToastProvider = ({ children }) => {
  const [toasts, setToasts] = useState([]);

  const addToast = useCallback((message, type = 'success', duration = 3000) => {
    const id = Date.now() + Math.random();
    setToasts((prev) => [...prev, { id, message, type }]);
    setTimeout(() => {
      setToasts((prev) => prev.filter((t) => t.id !== id));
    }, duration);
  }, []);

  const removeToast = useCallback((id) => {
    setToasts((prev) => prev.filter((t) => t.id !== id));
  }, []);

  return (
    <ToastContext.Provider value={{ addToast }}>
      {children}
      {/* Toast Container */}
      <aside
        className="fixed bottom-4 right-4 z-[9999] flex flex-col gap-2 max-w-sm"
        aria-live="polite"
      >
        {toasts.map((toast) => (
          <Toast key={toast.id} toast={toast} onClose={() => removeToast(toast.id)} />
        ))}
      </aside>
    </ToastContext.Provider>
  );
};

const Toast = ({ toast, onClose }) => {
  const styles = {
    success: 'bg-green-50 border-green-300 text-green-800',
    error: 'bg-red-50 border-red-300 text-red-800',
    info: 'bg-blue-50 border-blue-300 text-blue-800',
    warning: 'bg-yellow-50 border-yellow-300 text-yellow-800',
  };

  const icons = {
    success: <FiCheck className="text-green-600" />,
    error: <FiAlertCircle className="text-red-600" />,
    info: <FiInfo className="text-blue-600" />,
    warning: <FiAlertCircle className="text-yellow-600" />,
  };

  return (
    <article
      className={`flex items-center gap-3 border rounded-lg px-4 py-3 shadow-lg animate-slide-in ${styles[toast.type]}`}
    >
      <span className="text-lg flex-shrink-0">{icons[toast.type]}</span>
      <p className="text-sm font-medium flex-1">{toast.message}</p>
      <button onClick={onClose} className="flex-shrink-0 opacity-60 hover:opacity-100 transition">
        <FiX />
      </button>
    </article>
  );
};

export const useToast = () => useContext(ToastContext);
